import React, { useState } from "react";

import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";

export type FeedbackIconButtonProps = IconButtonProps & {
	children?: React.ReactNode;
	singleUse?: boolean;

	onClick?: () => Promise<void>;
};

const FeedbackIconButton: React.FC<FeedbackIconButtonProps> = (
	props: FeedbackIconButtonProps
) => {
	const [loading, setLoading] = useState(false);

	function handleClick(): void {
		if (props.onClick === undefined) {
			return;
		}

		setLoading(true);
		const click = props.onClick();

		if (!props.singleUse) {
			click.finally(() => setLoading(false));
		}
	}

	return <Box sx={{ position: "relative" }}>
		<IconButton
			aria-label={props["aria-label"]}
			disabled={loading || props.disabled}
			onClick={handleClick}
			size={props.size}
		>
			{props.children}
		</IconButton>
		{loading && (
			<CircularProgress
				size={24}
				sx={{
					position: "absolute",
					top: "50%",
					left: "50%",
					marginTop: "-12px",
					marginLeft: "-12px"
				}}
			/>
		)}
	</Box>;
};

export default FeedbackIconButton;
